import { render, staticRenderFns } from "./RatingTableItem.vue?vue&type=template&id=3f8e143f&"
import script from "./RatingTableItem.vue?vue&type=script&lang=js&"
export * from "./RatingTableItem.vue?vue&type=script&lang=js&"
import style0 from "./RatingTableItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports